import script from "./BillingItemsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingItemsPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTd});
